import { render, staticRenderFns } from "./AssignCourseToBdoCard.vue?vue&type=template&id=45ceb422&scoped=true&"
import script from "./AssignCourseToBdoCard.vue?vue&type=script&lang=js&"
export * from "./AssignCourseToBdoCard.vue?vue&type=script&lang=js&"
import style0 from "./AssignCourseToBdoCard.vue?vue&type=style&index=0&id=45ceb422&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ceb422",
  null
  
)

export default component.exports